import fetch from "../utils/fetch";

//商户数据汇总
export const fetchCompanyStatistics = ({
  field = "",
  rule = "",
  beginTime = "",
  endTime = "",
  pageNum,
  pageSize,
}) =>
  fetch(
    `statistics/company?field=${field}&rule=${rule}&beginTime=${beginTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}`
  );

//设备数据汇总
export const fetchEquipmentStatistics = ({
  field = "",
  rule = "",
  beginTime = "",
  endTime = "",
  pageNum,
  pageSize,
}) =>
  fetch(
    `statistics/capsule?field=${field}&rule=${rule}&beginTime=${beginTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}`
  );

//退款记录
export const fetchRefundRecord = ({
  beginTime,
  endTime,
  pageNum,
  pageSize,
  tradeNo,
  companyName,
}) =>
  fetch(
    `statistics/refund/list?beginTime=${beginTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}&tradeNo=${tradeNo}&companyName=${companyName}`
  );
